import { Injectable } from '@angular/core';
import { UsuariosService } from '../usuarios/usuarios.service';
import { Subject } from 'rxjs/internal/Subject';
import { environment } from 'src/environments/environment';
declare var SockJS: any;
declare var Stomp: any;

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  constructor(
    private _usuariosService: UsuariosService
  ) {
  }

  public stompClient: any;
  private reconnectInterval: any;
  private reconnecting: boolean = false;

  private eventoNotaSubject = new Subject<any>();
  public eventoNota$ = this.eventoNotaSubject.asObservable();

  private eventoEstadoAlumnos = new Subject<any>();
  public eventoEstadoAlumnosObs$ = this.eventoEstadoAlumnos.asObservable();

  private connectionStatusSubject = new Subject<string>();
  public connectionStatus$ = this.connectionStatusSubject.asObservable();

  initializeWebSocketConnection(params: {anyo: number, periodoId: number, asignaturaId: number, sedeId: number, seccionId: number }) {
    const serverUrl = environment.endpointDocente+'/registroNotas';
    const ws = new SockJS(serverUrl);
    this.stompClient = Stomp.over(ws);

    ws.onclose = (event: any) => {
      this.connectionStatusSubject.next('closed');
      this.tryReconnect(params);
    };

    ws.onerror = (error: any) => {
      this.connectionStatusSubject.next('error');
      this.tryReconnect(params);
    };

    const token = this._usuariosService.getToken()
    this.stompClient.connect({ Authorization: `Bearer ${token}` }, (frame: any) => {
      // subscribe notas
      this.connectionStatusSubject.next('connected');
      this.stompClient.subscribe(`/topic/notas/${params.anyo}-${params.periodoId}-${params.asignaturaId}-${params.sedeId}-${params.seccionId}`, (message : any) => {
        if (message.body) {
          this.eventoNotaSubject.next(JSON.parse(message.body)); // Emitir evento
        }
      });

      // subscribe estado alumnos
      this.stompClient.subscribe(`/topic/alumnos/${params.anyo}-${params.periodoId}-${params.asignaturaId}-${params.sedeId}-${params.seccionId}`, (message : any) => {
        if (message.body) {
          this.eventoEstadoAlumnos.next(JSON.parse(message.body)); // Emitir evento
        }
      });
      this.stopReconnectionAttempts();
    }, (error: any) => {
      this.connectionStatusSubject.next('disconnected');
      this.tryReconnect(params);
    });
  }
  
  sendMessage(params: {anyo: number, periodoId: number, asignaturaId: number, sedeId: number, seccionId: string }, message: any) {
    this.stompClient.send(`/app/registroNotas/${params.anyo}-${params.periodoId}-${params.asignaturaId}-${params.sedeId}-${params.seccionId}`, {}, message);
  }

  sendEstadosAlumnos(params: {anyo: number, periodoId: number, asignaturaId: number, sedeId: number, seccionId: string }, message: any) {
    this.stompClient.send(`/app/registroNotas/alumnos/${params.anyo}-${params.periodoId}-${params.asignaturaId}-${params.sedeId}-${params.seccionId}`, {}, message);
  }

  private tryReconnect(params: {anyo: number, periodoId: number, asignaturaId: number, sedeId: number, seccionId: number }) {
    if (!this.reconnecting) {
      this.reconnecting = true;
      this.reconnectInterval = setInterval(() => {
        this.initializeWebSocketConnection(params);
      }, (environment.tiempoReconexionSocket * 1000));
    }
  }

  private stopReconnectionAttempts() {
    if (this.reconnectInterval) {
      clearInterval(this.reconnectInterval);
      this.reconnectInterval = null;
      this.reconnecting = false;
    }
  }

  disconnect(): void {
    if (this.stompClient && this.stompClient !== null) {
      this.stompClient.disconnect(function() {
      });
      this.stompClient = null;
    }
    this.stopReconnectionAttempts();
  }
}
